export class PayrollFilter {
    from: string;
    to: string;
    type: string;
}


// WEBPACK FOOTER //
// ./src/app/models/salaries/payroll.filter.ts